module.exports = __webpack_public_path__ + "static/media/plutotv-logo-min.33716c23.svg";